import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import ChartHeader from 'components/charts/ChartHeader';
import StatisticsDataCards from 'components/charts/StatisticsDataCards';
import LineChartV2 from 'components/charts/chartJS/LineChart';
import Typography from 'components/global/Typography';

import useFetchAndParseOnView from 'hooks/useFetchAndParseOnView';

import { REPORT } from 'services/consts';

import { colorCombinations } from 'utils/colors';

import * as S from './CompanyKPIDashboard.styled';

const CompanyKPIDashboard = () => {
	const { t } = useTranslation();
	const parseData = ({ data }) => {
		const labels = data.map((item) => item.WeekNumber);
		const datasets = [
			{
				label: t('omniAggregatorOrder'),
				data: data.map((item) => item.omniAggregatorOrder),
				backgroundColor: colorCombinations[0].color,
				borderColor: colorCombinations[0].color
			},
			{
				label: t('integratorOrder'),
				data: data.map((item) => item.integratorOrder),
				backgroundColor: colorCombinations[1].color,
				borderColor: colorCombinations[1].color
			},
			{
				label: t('aggregatorOrder'),
				data: data.map((item) => item.aggregatorOrder),
				backgroundColor: colorCombinations[2].color,
				borderColor: colorCombinations[2].color
			}
		];
		return { labels, datasets };
	};

	const dataCardConfigs = [
		{
			accessor: 'thisWeek',
			customIcon: 'fa-regular fa-calendar',
			label: 'dashboard.statistic.thisWeek'
		},
		{
			accessor: 'lastWeek',
			customIcon: 'fa-regular fa-calendar',
			label: 'dashboard.statistic.lastWeek'
		},
		{
			accessor: 'sameWeekLastMonth',
			customIcon: 'fa-regular fa-calendar',
			label: 'dashboard.statistic.sameWeekLastMonth'
		},
		{
			accessor: 'sameWeekLastYear',
			customIcon: 'fa-regular fa-calendar',
			label: 'dashboard.statistic.sameWeekLastYear'
		}
	];

	const body = useMemo(() => ({}), []);

	const { ref, data, loading } = useFetchAndParseOnView({
		url: REPORT.OTO.COMPANY_KPI_DASHBOARD_WEEKLY,
		body,
		parseData
	});

	return (
		<S.Container>
			<div className="row row-cols-1 row-cols-lg-1">
				<ChartHeader title="orderBaseKPI" />
				<StatisticsDataCards
					fetchURL={REPORT.OTO.GET_COMPARED_ORDER_WEEKLY}
					cardConfigs={dataCardConfigs}
					itemsPerRow={4}
				/>
			</div>
			<S.SmallCard ref={ref}>
				<Typography fontWeight="700" gutterBottom>
					companyKpiDashboard
				</Typography>
				<LineChartV2 data={data} loading={loading} xTitle="weekNumber" yTitle="numberOfOrders" />
			</S.SmallCard>
		</S.Container>
	);
};

export default CompanyKPIDashboard;
